<template>
  <v-tooltip
    top
    color="warning"
  >
    <template #activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
      >
        <v-checkbox
          v-model="slaAlertaAtivo"
          readonly
          :label="slaAlertaLabel"
        />
      </div>
    </template>

    <span>O alerta se torna ativo quando Gestor ou Agente e Browser ou Badge são marcados</span>
  </v-tooltip>
</template>

<script>
import { ref, watch, watchEffect } from '@vue/composition-api'

export default {
  props: {
    slaAlerta: {
      type: Object,
      required: true,
    },
    niveisAlerta: {
      type: Object,
      required: true,
    },
    getIsAlertaValido: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const slaAlertaLocale = ref()
    const slaAlertaLabel = ref('')
    const slaAlertaAtivo = ref(false)

    watch(
      () => props.slaAlerta,
      v => {
        slaAlertaLocale.value = JSON.parse(JSON.stringify(v))
        slaAlertaLabel.value = props.niveisAlerta[slaAlertaLocale.value.tipoAlertaId]
      },
      { deep: true, immediate: true },
    )

    watchEffect(() => {
      slaAlertaAtivo.value = props.getIsAlertaValido(slaAlertaLocale.value)
    })

    return {
      slaAlertaLocale,
      slaAlertaAtivo,
      slaAlertaLabel,
    }
  },

}
</script>
